import PropTypes from "prop-types"


const ImportErrorShape = PropTypes.exact({
  index: PropTypes.number,
  reason: PropTypes.string,
})

export default ImportErrorShape
